function extractText(html?: string | null) {
  if (!html) return true;
  const x = document.createElement('div');
  x.innerHTML = html;
  return x.innerText.trim();
}

export default extractText;
